import RandomizeBuild from './RandomizeBuild';

export default RandomizeBuild;
export { RandomizeBuild };
